import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/'
import store from './store'
import './assets/css/main.css';
Vue.config.productionTip = false
import VueHtmlToPaper from 'vue-html-to-paper';


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.rtl.min.css',
    // يمكنك إضافة رابط ملف الستايل الخاص بك هنا أيضاً إذا كنت تستخدم ملفاً خارجياً
        '/css/adminlte.rtl.css',
    '/assets/css/rtl.css',
  ],
  timeout: 1000, // وقت الانتظار لضمان تحميل الصور والخطوط قبل الطباعة
  autoClose: true,
};

Vue.use(VueHtmlToPaper, options);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
